var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("ListingWrapperLoadingState")
    : _c(
        "div",
        { staticClass: "listing-wrapper" },
        [
          _c("LayoutHeadingTabs", {
            attrs: { title: _vm.title },
            scopedSlots: _vm._u(
              [
                {
                  key: "tabs",
                  fn: function() {
                    return [_vm._t("listingTabs")]
                  },
                  proxy: true
                },
                {
                  key: "actions",
                  fn: function() {
                    return [_vm._t("listingActions")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "listing-wrapper__table-container" },
            [
              _c(
                "div",
                { staticClass: "listing-wrapper-settings-header__container" },
                [_vm._t("settings")],
                2
              ),
              _vm._v(" "),
              _vm._t("table"),
              _vm._v(" "),
              _vm.paginationData.total > 0
                ? _c("TablePagination", {
                    staticClass: "listing-wrapper__pagination",
                    attrs: {
                      pagination: _vm.paginationData,
                      isLoading: _vm.isTableLoading
                    },
                    on: { "update-pagination": _vm.updatePagination }
                  })
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }